import { render, staticRenderFns } from "./SingleProducts.vue?vue&type=template&id=be2a70ae&scoped=true&"
import script from "./SingleProducts.vue?vue&type=script&lang=js&"
export * from "./SingleProducts.vue?vue&type=script&lang=js&"
import style0 from "./SingleProducts.vue?vue&type=style&index=0&id=be2a70ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2a70ae",
  null
  
)

export default component.exports